import { IInputSpinnerTheme } from '../../models/IInputSpinner';
import { colors } from './colors';

export const inputSpinnerTheme: IInputSpinnerTheme = {
  input: {
    color: colors.neutral.gray,
    borderColor: colors.neutral.grayWarm,
    fontSize: '17px',
    lineHeight: '20px',
    backgroundColor: colors.neutral.white,
  },
  button: {
    color: colors.neutral.black,
    borderColor: colors.neutral.grayWarm,
    backgroundColor: colors.neutral.white,
  },
  sizes: {
    md: {
      width: '140px',
      height: '40px',
    },
    sm: {
      width: '110px',
      height: '30px',
    },
  },
};
